type DateOptions = {
  minute?: 'numeric' | '2-digit';
  hour?: 'numeric' | '2-digit';
  day?: 'numeric' | '2-digit';
  month?: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow';
  year?: 'numeric' | '2-digit';
  timeZone?: string;
}

export default defineNuxtPlugin(() => {
  const formatDate = (val: string | number | Date, format: string, timezone: string) => {
    const { $lang } = useNuxtApp()
    const date = new Date(val)
    let locale = 'nl-NL'
    const dateOptions:DateOptions = {}

    switch ($lang) {
      case 'de':
        locale = 'de-DE'
        break
      case 'en':
        locale = 'en-UK'
        break
      case 'fr':
        locale = 'fr-FR'
        break
      default:
        locale = 'nl-NL'
        break
    }

    if (timezone) {
      dateOptions.timeZone = timezone
    }

    switch (format) {
      case 'hh:mm':
        dateOptions.hour = '2-digit'
        dateOptions.minute = '2-digit'
        return date.toLocaleTimeString([locale], dateOptions)
      case 'dd mm yyyy':
        dateOptions.month = 'long'
        dateOptions.day = 'numeric'
        dateOptions.year = 'numeric'
        return date.toLocaleDateString([locale], dateOptions)
      case 'dd mm':
        dateOptions.month = 'long'
        dateOptions.day = 'numeric'
        return date.toLocaleDateString([locale], dateOptions)
      case 'dd m':
        dateOptions.month = 'short'
        dateOptions.day = 'numeric'
        return date.toLocaleDateString([locale], dateOptions)
      case 'dd mm hh:mm':
        dateOptions.month = 'long'
        dateOptions.day = 'numeric'
        dateOptions.hour = '2-digit'
        dateOptions.minute = '2-digit'
        return date.toLocaleDateString([locale], dateOptions)
      default:
        dateOptions.month = 'long'
        dateOptions.day = 'numeric'
        dateOptions.year = 'numeric'
        dateOptions.hour = '2-digit'
        dateOptions.minute = '2-digit'
        return date.toLocaleDateString([locale], dateOptions)
    }
  }

  return {
    provide: {
      formatDate
    }
  }
})
